//import './style.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as reportActions from '../../redux/actions/report.action'
import NumberFormat from 'react-number-format'
import { RootReducers } from '../../redux/reducers'
import { HeaderBar } from '../../component/HeaderBar'
import { ChangeEvent, useEffect, useState } from 'react'
import { CSVLink, CSVDownload } from 'react-csv'
import errorAlert from '../../assets/images/error-alert.svg'
import {
  DisplayDateReportFormatNoTime,
  DisplayToThaiDateFormat,
  ReportDateFormat
} from '../../helpers/texthelper'
import { WatDatePicker } from '../../component/datePicker'
import { FWDCKC } from './FWD_CKC'
import { QRCode } from './QRCode'
import { CKCPayIn } from './CKC pay in'
import { mockPaymentDetail } from '../../constants'
import { Cash } from './Cash'

export const PaymentDetail = () => {
  const dispatch = useDispatch()
  const documentId = 1

  const [formErrors, setFormErrors] = useState<any>({})

  useEffect(() => {
    console.log('FirstLoad')
  }, [])

  const aa = (data: any) => {
    console.log(data)
  }
  return (
    <div>
      <HeaderBar>
        <div className="header-bar-text">PaymentDetail</div>
      </HeaderBar>
      <div className="container">
        <div className="form-content"></div>
        <div className="form-content">
          <FWDCKC
            paymentDetail={mockPaymentDetail}
            documentId={documentId}
            setPaymentDetailFormValue={aa}
          />
        </div>
        <div className="form-content">
          <QRCode
            label="QRCode"
            paymentDetail={mockPaymentDetail}
            documentId={documentId}
            setPaymentDetailFormValue={aa}
          />
        </div>
        <div className="form-content">
          <CKCPayIn
            documentId={documentId}
            paymentDetail={mockPaymentDetail}
            setPaymentDetailFormValue={aa}
          />
        </div>
      </div>
    </div>
  )
}
